import React from 'react';

interface Props {
  height?: number;
  width?: number;
}

export function PhotoUploadIcon({ height = 24, width = 24 }: Props) {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H12C12.3778 0 12.6944 0.127778 12.95 0.383333C13.2056 0.638889 13.3333 0.955556 13.3333 1.33333C13.3333 1.71111 13.2056 2.02778 12.95 2.28333C12.6944 2.53889 12.3778 2.66667 12 2.66667H2.66667V21.3333H21.3333V12C21.3333 11.6222 21.4611 11.3056 21.7167 11.05C21.9722 10.7944 22.2889 10.6667 22.6667 10.6667C23.0444 10.6667 23.3611 10.7944 23.6167 11.05C23.8722 11.3056 24 11.6222 24 12V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM4 18.6667H20L15 12L11 17.3333L8 13.3333L4 18.6667ZM18.6667 5.33333H17.3333C16.9556 5.33333 16.6389 5.20556 16.3833 4.95C16.1278 4.69444 16 4.37778 16 4C16 3.62222 16.1278 3.30556 16.3833 3.05C16.6389 2.79444 16.9556 2.66667 17.3333 2.66667H18.6667V1.33333C18.6667 0.955556 18.7944 0.638889 19.05 0.383333C19.3056 0.127778 19.6222 0 20 0C20.3778 0 20.6944 0.127778 20.95 0.383333C21.2056 0.638889 21.3333 0.955556 21.3333 1.33333V2.66667H22.6667C23.0444 2.66667 23.3611 2.79444 23.6167 3.05C23.8722 3.30556 24 3.62222 24 4C24 4.37778 23.8722 4.69444 23.6167 4.95C23.3611 5.20556 23.0444 5.33333 22.6667 5.33333H21.3333V6.66667C21.3333 7.04445 21.2056 7.36111 20.95 7.61667C20.6944 7.87222 20.3778 8 20 8C19.6222 8 19.3056 7.87222 19.05 7.61667C18.7944 7.36111 18.6667 7.04445 18.6667 6.66667V5.33333Z"
        fill="#75757C"
      />
    </svg>
  );
}
